import {TextField} from '@wix/wix-ui-tpa/cssVars';
import React from 'react';
import {classes} from './EmailField.st.css';
import {useLocaleKeys} from '../../../locale-keys/LocaleKeys';

export const EmailField = ({
  dataHook,
  label,
  value,
  hasError,
  onChange,
}: {
  dataHook: string;
  label: string;
  value?: string;
  hasError: boolean;
  onChange: (value: string) => void;
}) => {
  const localeKeys = useLocaleKeys();
  return (
    <TextField
      data-hook={dataHook}
      className={classes.email}
      label={label}
      value={value}
      required
      error={hasError}
      errorMessage={localeKeys.checkout.emailField.input.error.message()}
      newErrorMessage={true}
      onChange={(event) => onChange(event.target.value)}
    />
  );
};
